import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["brand", "categoryId", "pageSize", "sellerId", "subCategoryId", "sortOrientation", "sortType"];
import React from 'react';
import { bool, string, number, shape } from 'prop-types';
import { useProductListBySeller } from '@magalu/mixer-graphql';
import ProductCarousel from './ProductCarousel';
var ProductCarouselSeller = function ProductCarouselSeller(_ref) {
  var data = _ref.data,
    _ref$static = _ref["static"],
    _ref$static$brand = _ref$static.brand,
    brand = _ref$static$brand === void 0 ? '' : _ref$static$brand,
    _ref$static$categoryI = _ref$static.categoryId,
    categoryId = _ref$static$categoryI === void 0 ? '' : _ref$static$categoryI,
    _ref$static$pageSize = _ref$static.pageSize,
    pageSize = _ref$static$pageSize === void 0 ? 10 : _ref$static$pageSize,
    sellerId = _ref$static.sellerId,
    _ref$static$subCatego = _ref$static.subCategoryId,
    subCategoryId = _ref$static$subCatego === void 0 ? '' : _ref$static$subCatego,
    _ref$static$sortOrien = _ref$static.sortOrientation,
    sortOrientation = _ref$static$sortOrien === void 0 ? '' : _ref$static$sortOrien,
    sortType = _ref$static.sortType,
    staticProps = _objectWithoutProperties(_ref$static, _excluded),
    structure = _ref.structure;
  var _useProductListBySell = useProductListBySeller({
      brand: brand,
      categoryId: categoryId,
      pageSize: pageSize,
      sellerId: sellerId,
      sortOrientation: sortOrientation,
      sortType: sortType,
      subCategoryId: subCategoryId
    }),
    productList = _useProductListBySell.productList;
  return productList.length ? React.createElement(ProductCarousel, {
    data: _extends({}, data, {
      search: {
        products: productList
      }
    }),
    "static": _extends({}, staticProps),
    structure: structure
  }) : null;
};
process.env.NODE_ENV !== "production" ? ProductCarouselSeller.propTypes = {
  data: shape({}),
  "static": shape({
    allowEmptyRating: bool,
    auto: bool,
    brand: string,
    buttonProps: shape({}),
    cardType: string,
    categoryId: string,
    colorMinLength: number,
    context: shape({}),
    displayMode: string,
    domain: string,
    enableHover: bool,
    gutter: number,
    hideOriginalPrice: bool,
    imageAltPrefix: string,
    imageHeight: number,
    imageWidth: number,
    imgLazyLoading: bool,
    inCashDescription: string,
    interval: number,
    isSellerPage: bool,
    isSlider: bool,
    origin: string,
    pageSize: number,
    position: number,
    productTitleAs: string,
    sellerId: string,
    showArrowControls: bool,
    showBorder: bool,
    showButton: bool,
    showControls: bool,
    showDiscount: bool,
    showDiscountOnlyCashInfo: bool,
    showInCashLabel: bool,
    showOfferTimer: bool,
    showPartialNextSlide: bool,
    showRating: bool,
    showWishBtn: bool,
    slidesPerView: number,
    sortOrientation: string,
    sortType: string,
    spa: bool,
    subCategoryId: string,
    transitionDuration: number,
    type: string
  }),
  structure: shape({})
} : void 0;
ProductCarouselSeller.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
export default ProductCarouselSeller;